import { useEffect, useState } from "react";
import { CTA_MODE, appHref } from "@/config";
import { scrollToLeadForm } from "@/lib/scroll";

export const StickyBar = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="sticky-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-surface2/97 p-3 backdrop-blur-md md:hidden"
    >
      {CTA_MODE === "app" ? (
        <a data-testid="sticky-cta" href={appHref("renter")} className="nb-btn-primary w-full">
          Open the app
        </a>
      ) : (
        <button
          data-testid="sticky-cta"
          type="button"
          onClick={() => scrollToLeadForm()}
          className="nb-btn-primary w-full"
        >
          Get a callback
        </button>
      )}
    </div>
  );
};
